import colors from 'vuetify/es5/util/colors'

export default {
  default: {
    colors: {
      primary: colors.indigo.base,
      background: '#373c40',
      secondary: '#b0bec5',
      accent: '#8c9eff',
      error: '#b71c1c',
      card: '#1b2024'
    }
  },
  route: {
    'booking-edit': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'privacy-policy': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'legal-advice': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'cookies-policy': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'login': {
      colors: {
        primary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'inspire': {
      colors: {
        primary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'change-password': {
      colors: {
        primary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'recover-password': {
      colors: {
        primary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'register': {
      colors: {
        primary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'store': {
      colors: {
        primary: colors.orange.base,
        secundary: colors.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'calendar': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'account': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'accounts': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'new-account': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'account-user-id': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipment': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipments': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipment-id': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'dashboard': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        warning: '#ff9800'
      },
      styles: {
        card: 'light'
      }
    },
    'create-reservation': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        success: '#0097a7',
        info: '#2196f3',
        error: '#ff5252',
        warning: '#ff9800'
      },
      styles: {
        card: 'light'
      }
    },
    'business-groups': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'companies': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'equipment-brands': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'brand-models': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'equipment-types': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'bookings': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'admins': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'commerces': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'installers': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'managers': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'responsibles': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-id': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'bookingnew': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-added': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-new': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'indoor-unit-models': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'outdoor-unit-models': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'power-sources': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'types': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'installation-type-id': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'installation-costs': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'refrigerant-types': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'refrigerant-quantity': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'model-features': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'billing-types': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'payment-methods': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'material-designations': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'exclusions': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'stats': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'inclusions': {
      colors: {
        primary: colors.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/theme.js